export default "__VITE_ASSET__CRUGthvp__"